// export const environment = {
// 	production: true,
// 	firebaseConfig: {
// 		apiKey: 'AIzaSyAit0M9mMKuY3oVcXF-IrFFnvy3ZfliS3w',
// 		authDomain: 'hubble-159a2.firebaseapp.com',
// 		databaseURL:
// 			'https://hubble-159a2-default-rtdb.asia-southeast1.firebasedatabase.app',
// 		projectId: 'hubble-159a2',
// 		storageBucket: 'hubble-159a2.appspot.com',
// 		messagingSenderId: '302493094096',
// 		appId: '1:302493094096:web:afba897677aa13aa6d8ed5',
// 		measurementId: 'G-2JMXMHWMQ5',
// 	},
// 	url: {
// 		profile: 'https://terra-api.terra.do/dev/profile',
// 		hubble: 'https://terra-api.terra.do/dev/hubble',
// 		cohort: 'https://terra-api.terra.do/dev/cohortdev',
// 		class: 'https://api.terra.do/stage/classdev',
// 		company: 'https://terra-api.terra.do/dev/portfoliodev',
// 		catalog: 'https://terra-api.terra.do/dev/cataloogdev',
// 	},
// };
export const environment = {
	production: true,
	firebaseConfig: {
		apiKey: 'AIzaSyAnTrhlFHG3S0NLd8N_lbQoeanwguQgSZg',
		authDomain: 'hubble-prod-dcbd4.firebaseapp.com',
		projectId: 'hubble-prod-dcbd4',
		storageBucket: 'hubble-prod-dcbd4.appspot.com',
		messagingSenderId: '449220924469',
		appId: '1:449220924469:web:765fe3993298bd7dc3cd7c',
		measurementId: 'G-NQBTLEEN2D',
	},
	url: {
		profile: 'https://jobs.terra.do/profile',
		hubble: 'https://api.terra.do/stage/hubble',
		cohort: 'https://cohort.terra.do/cohort',
		class: 'https://api.terra.do/beta/class',
		company: 'https://jobs.terra.do/portfolio',
		catalog: 'https://course.terra.do/catalog',
	},
};
